import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import IndustriesPage from "@/pages/IndustriesPage";
import ContactPage from "@/pages/ContactPage";

const titles = {
  "/": "VORTEX CORE IT SERVICES LLC | Dubai IT Solutions",
  "/about": "About | VORTEX CORE IT SERVICES LLC",
  "/services": "Services | VORTEX CORE IT SERVICES LLC",
  "/industries": "Industries | VORTEX CORE IT SERVICES LLC",
  "/contact": "Contact | VORTEX CORE IT SERVICES LLC",
};

function RouteEffects() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.title = titles[pathname] || titles["/"];
  }, [pathname]);

  return null;
}

function AppShell() {
  return (
    <>
      <RouteEffects />
      <SiteHeader />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <SiteFooter />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
